import { useState, useEffect, type Dispatch, type SetStateAction } from "react";
import { getAgencyNamesRefinementList } from "components/_dashboard/listingsMatch/algoliaClient";
import type { ListingOrigin } from "../@types/sharedSchema";
import { useAlgoliaIndex } from "../contexts/AlgoliaClientContext";
import { isPgSearchEnabled } from "utils/listingsSearchApi";

type AgencyNames = {
  search: string;
  loading: boolean;
  agencyNames: string[];
  setSearch: Dispatch<SetStateAction<string>>;
};

export function useAgencyNames(listingOrigin?: ListingOrigin): AgencyNames {
  const [search, setSearch] = useState("");
  const [agencyNames, setAgencyNames] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const algoliaIndex = useAlgoliaIndex();

  useEffect(() => {
    // The facet comes from the server in Postgres mode, so there's no index to
    // wait for — gating on one would leave the filter permanently empty.
    if (!isPgSearchEnabled() && !algoliaIndex) return;

    const fetchAgencyNames = async (): Promise<void> => {
      setLoading(true);
      try {
        const results = await getAgencyNamesRefinementList(
          algoliaIndex,
          search,
          0,
          100,
          listingOrigin
        );
        setAgencyNames(results);
      } catch (error) {
        console.error("Error fetching agency names:", error);
      } finally {
        setLoading(false);
      }
    };

    void fetchAgencyNames();
  }, [search, algoliaIndex, listingOrigin]);

  return { agencyNames, search, loading, setSearch };
}
